import AccountTypesPanel from './AccountTypesPanel';

export default AccountTypesPanel;
